const canUseWindowRequire = () =>
    typeof window !== "undefined" &&
    typeof (window as any).require === "function";

export const isElectron = ({alert}: { alert?: boolean }) => {
    let valid = false;

    if (!canUseWindowRequire()) {
        if (alert && typeof window !== "undefined")
            window.alert(
                "Ova mogućnost dostpuna je samo u Onix Desktop aplikaciji!",
            );

        return false;
    }

    // Renderer process
    if (
        typeof window !== "undefined" &&
        typeof window.process === "object" &&
        (window.process as any)?.type === "renderer"
    ) {
        valid = true;
    }

    // Main process
    if (
        typeof process !== "undefined" &&
        typeof process.versions === "object" &&
        !!process.versions.electron
    ) {
        valid = true;
    }

    // Detect the user agent when the `nodeIntegration` option is set to true
    if (
        typeof navigator === "object" &&
        typeof navigator.userAgent === "string" &&
        navigator.userAgent.indexOf("Electron") >= 0
    ) {
        valid = true;
    }

    if (alert && !valid)
        window.alert("Ova mogućnost dostpuna je samo u Onix Desktop aplikaciji!");

    return valid;
};

export const isMac = () => {
    if (isElectron({})) {
        return (window as any).process.platform === "darwin";
    } else {
        return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    }
};
